import React, { memo, useState } from 'react';
import { View, Image } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';
import {
  WorkspaceDashboardHeaderUserInfo,
  ToolTip,
} from '@redlink/components/molecules';
import { useQuery, getUserProfileQuery } from '@redlink/services';
import { HeaderTooltipTemplate } from '@redlink/components/templates';
import {  ProfileChangePasswordPage } from '../pages';

export const WorkspaceHeader = memo(({ navigation }) => {
  const { styles } = useStyle();
  const [passwordIsVisible, setPasswordIsVisible] = useState(false);

  const {
    loading: getUserProfileIsBusy,
    data: { UserProfile: { username} = {} },
  } = useQuery(getUserProfileQuery);

  return (
    <View style={styles.container}>
      <Image
        source={require('@redlink/assets/images/logo.png')}
        style={styles.logo}
      />
      <View style={styles.headerLeftContainer}>
        <Text style={styles.headerText}>REDLINK</Text>
      </View>
      {!getUserProfileIsBusy && (
        <View style={styles.headerRightContainer}>
          <ToolTip
            renderButton={() => (
              <WorkspaceDashboardHeaderUserInfo text={username} />
            )}
          >
            <HeaderTooltipTemplate
              workspace
              onPasswordManagementPress={() => setPasswordIsVisible(true)}
            />
          </ToolTip>
        </View>
      )}
      <ProfileChangePasswordPage
        isVisible={passwordIsVisible}
        onDismiss={() => setPasswordIsVisible(false)}
      />
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow, theme }) => ({
  container: {
    backgroundColor: colors.white,
    height: size.headerHeight,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 39,
    ...shadow.header,
  },
  logo: {
    width: 28,
    height: 34,
  },
  headerLeftContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 40,
  },
  headerRightContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: 'flex-end',
    paddingHorizontal: 40,
  },
  signOutButton: {
    width: 48,
    height: 48,
  },
  headerText: {
    color: colors.gray21,
    fontSize: 14,
    letterSpacing: 5,
    flex: 1,
    textAlign: 'center',
  },
}));
